import React from 'react';
import NotificationsPage from '../Notificaciones/NotificationsPage';
import NavigationUser from '../Layouts/Navigation/NavigationUser';

export default function UserNotificaciones() {
  return <NotificationsPage NavigationComponent={NavigationUser} />;
}
